import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectMaterialsLowStock({ items }: { items: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Cảnh báo sắp hết hàng</h3>
        <button className="text-xs font-normal text-rose-600 hover:underline">Xem tất cả</button>
      </div>

      <div className="space-y-4">
        {items.map((item, idx) => (
          <div key={idx} className="space-y-1.5">
            <div className="flex justify-between items-start mb-1.5">
              <span className="text-xs font-normal text-slate-700 truncate flex-1">{item.name}</span>
              <span className="text-xs font-normal text-rose-600 ml-2">{item.stock} {item.unit}</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-50 overflow-hidden">
               <div className={cn("h-full transition-all duration-700", item.percent < 20 ? 'bg-rose-500' : 'bg-orange-500')} style={{ width: `${item.percent}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
